// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"706":"79da227d","787":"af891aa7","909":"3789b170"}[chunkId] + ".chunk.js";
};